import Vue from 'vue';
import Component from 'vue-class-component';
import SketchfabFrame from '../sketchfabFrame/SketchfabFrame.vue';
import { Prop, Inject } from 'vue-property-decorator';
import { ConfiguratorService, ConfiguratorServiceSettings, HideObjectsCommand, FilterOperators } from '../../services/sketchfab/index';
import { Store } from '@/store';
import { ServiceIdentifiers } from '@/services';
import { ComponentContainer } from '@/services/container';
import { ProductDefinition } from '@/models/configurator';
import * as _ from 'lodash';
import Family from '@/components/family/Family';
import VueRouter from 'vue-router';



@Component({
  components: {
    family: Family,
  },
})
export default class Controller extends Vue {
  private _configuratorService: ConfiguratorService = undefined;



  @Inject()
  private _container: ComponentContainer;


  @Prop()
  familyId: string;





  created() {

    this._configuratorService = this._container.get<ConfiguratorService>(ServiceIdentifiers.ConfiguratorService);




  }

  mounted() {


  }
}



// WEBPACK FOOTER //
// ./src/components/controller/Controller.ts